import React, { createContext, useContext, useState, useCallback } from 'react';

/**
 * SelectionContext — shared selection across GIS map, Section view, and 3D viewer.
 *
 * selection shape:
 * {
 *   type: 'line' | 'point' | 'anomaly' | 'cell' | null,
 *   name: string,
 *   coordinates?: [[lon,lat], ...]   // line geometry
 *   position?: [lon, lat]            // click/point location
 *   depth?: number                   // subsurface depth (section/3D picks)
 *   source: 'map' | 'section' | '3d'
 * }
 */
const SelectionContext = createContext({
  selection: null,
  setSelection: () => {},
  clearSelection: () => {},
});

export function SelectionProvider({ children }) {
  const [selection, setSelectionState] = useState(null);

  const setSelection = useCallback((sel) => {
    setSelectionState(sel ? { ...sel, at: Date.now() } : null);
  }, []);

  const clearSelection = useCallback(() => setSelectionState(null), []);

  return (
    <SelectionContext.Provider value={{ selection, setSelection, clearSelection }}>
      {children}
    </SelectionContext.Provider>
  );
}

export function useSelection() {
  return useContext(SelectionContext);
}

export default SelectionContext;
